// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1QS2r","rootSuccess":"CompleteLink_rootSuccess__2-SGx","rootFailure":"CompleteLink_rootFailure__22TaE","isDisabled":"CompleteLink_isDisabled__2ZDFX"};